<script>
import Addresses from "../Components/Addresses";
import Account from "@/components/_Shared/Users/Account/Index";
import OrdersHistory from "@/components/Orders/List";

import { mapActions } from "vuex";
import moment from "@/utils/moment";

export default {
  components: {
    Addresses,
    Account,
    OrdersHistory
  },

  data() {
    return {
      phone: "",
      birthdateLabel: "",
      customer: null,
      preloader: false
    };
  },

  methods: {
    ...mapActions("legals", ["show", "update"]),

    async getCustomer() {
      this.preloader = true;

      try {
        this.customer = await this.show(this.$route.params.id);
      } catch (e) {}

      this.preloader = false;
    },

    async updateData() {
      this.preloader = true;

      try {
        await this.update(this.customer);
      } catch (e) {}

      this.preloader = false;
    },

    formatBirthdate() {
      this.customer.profile.birthdate = moment(
        this.customer.profile.birthdate
      ).format("Y-MM-DD");
      this.birthdateLabel = moment(this.customer.profile.birthdate).format(
        "DD/MM/Y"
      );
    },

    formatPhone() {
      this.phone =
        this.customer.phones[0].area_code + this.customer.phones[0].number;
    }
  },

  watch: {
    customer() {
      this.formatPhone();
    },

    "customer.profile.birthdate": function() {
      this.formatBirthdate();
    }
  },

  mounted() {
    this.getCustomer();
  }
};
</script>

<template>
  <v-layout v-if="customer" column>
    <account :account="customer" @refresh="getCustomer()" />
    <addresses :accountable="customer.accountable" />
    <orders-history
      :user="{ type: customer.accountable.type, id: customer.accountable.id }"
    />
  </v-layout>
</template>

<style scoped>
.group-button {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Customers/Legals/Edit.vue